import { useResponsiveHelper } from "contexts/responsiveContext";
import { SignupFrameMaxWidth } from "../../pages/demo/constants/dialogFrame";
import { useDemoFormVersion } from "../../hooks/useDemoFormVersion";

export interface StatusStepInterface {
  StepView?: JSX.Element;
  connectorColor?: string;
}

interface StepperBaseProps {
  steps: StatusStepInterface[];
}

export const StepperBase = ({ steps }: StepperBaseProps) => {
  const { isMobile } = useResponsiveHelper();
  const { isTwoStepsDemoForm } = useDemoFormVersion();

  return (
    <div className="flex w-full items-center justify-center">
      <div
        className={`flex w-full ${isTwoStepsDemoForm ? "justify-evenly" : "justify-between"}`}
        style={{
          maxWidth: SignupFrameMaxWidth
        }}
      >
        {steps.map(({ connectorColor, StepView }, index) => {
          const showConnector = index > 0 && index <= steps.length - 1;
          const showMobileConnector = index >= 0 && index <= steps.length - 1;
          const bgColorClass = connectorColor || "bg-green-500";

          return (
            <div key={index} className="flex min-w-[88px]">
              <div className="relative">
                {((isMobile && showMobileConnector) || showConnector) && (
                  <div
                    className={`absolute left-[-50%] top-[15px] w-[calc(100%-15px)] ${
                      isMobile ? "z-[1]" : "z-10"
                    } transition-all duration-[2000ms] ${bgColorClass} h-[2px]`}
                  />
                )}
                {StepView}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
